import { render, staticRenderFns } from "./UploadSignature.vue?vue&type=template&id=15955c96&scoped=true&"
import script from "./UploadSignature.vue?vue&type=script&lang=js&"
export * from "./UploadSignature.vue?vue&type=script&lang=js&"
import style0 from "./UploadSignature.vue?vue&type=style&index=0&id=15955c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15955c96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VForm,VRow})
